


export const layouts = {
'404': () => import('/app/src/layouts/404.vue'),
'500': () => import('/app/src/layouts/500.vue'),
'auth-registration': () => import('/app/src/layouts/auth-registration.vue'),
'auth': () => import('/app/src/layouts/auth.vue'),
'blank': () => import('/app/src/layouts/blank.vue'),
'carrier-blocked': () => import('/app/src/layouts/carrier-blocked.vue'),
'carrier-email': () => import('/app/src/layouts/carrier-email.vue'),
'carrier': () => import('/app/src/layouts/carrier.vue'),
'default': () => import('/app/src/layouts/default.vue'),
'landing': () => import('/app/src/layouts/landing.vue'),
'components/AppNavbar': () => import('/app/src/layouts/components/AppNavbar.vue'),
'components/CarrierNavbar': () => import('/app/src/layouts/components/CarrierNavbar.vue'),
'components/CarrierNavigationItems': () => import('/app/src/layouts/components/CarrierNavigationItems.vue'),
'components/CarrierPortalNavbar': () => import('/app/src/layouts/components/CarrierPortalNavbar.vue'),
'components/CurrencyRecalcBanner': () => import('/app/src/layouts/components/CurrencyRecalcBanner.vue'),
'components/FeaturesCarousel': () => import('/app/src/layouts/components/FeaturesCarousel.vue'),
'components/Footer': () => import('/app/src/layouts/components/Footer.vue'),
'components/Navbar': () => import('/app/src/layouts/components/Navbar.vue'),
'components/navbar/CarrierMenu': () => import('/app/src/layouts/components/navbar/CarrierMenu.vue'),
'components/navbar/CarrierMenuContent': () => import('/app/src/layouts/components/navbar/CarrierMenuContent.vue'),
'components/navbar/LanguageSwitcher': () => import('/app/src/layouts/components/navbar/LanguageSwitcher.vue'),
'components/navbar/UserMenu': () => import('/app/src/layouts/components/navbar/UserMenu.vue'),
'components/navbar/UserMenuContent': () => import('/app/src/layouts/components/navbar/UserMenuContent.vue'),
'components/navbar/UserMenuItem': () => import('/app/src/layouts/components/navbar/UserMenuItem.vue'),
'components/navbar/WorkspacesContent': () => import('/app/src/layouts/components/navbar/WorkspacesContent.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  const inheritDefaultLayout = true

  function hasChildWithLayout(route) {
    if (!route.children || route.children.length === 0) {
      return false
    }
    return route.children.some(child => {
      // Check if child has layout in meta (before transformation)
      if (child.meta?.layout && child.meta.layout !== false) {
        return true
      }
      // Also check if child is already a layout route (after transformation)
      if (child.meta?.isLayout) {
        return true
      }
      return hasChildWithLayout(child)
    })
  }

  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      // Check if child has layout before transforming children (only when inheritDefaultLayout is false)
      const childHasLayout = top && !inheritDefaultLayout && route.children?.length > 0
        ? hasChildWithLayout(route)
        : false

      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }

      if (top) {
        // auto-routes adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          // If inheritDefaultLayout is true, always apply default layout (original behavior)
          // If inheritDefaultLayout is false, only apply if child doesn't have its own layout
          const shouldApplyDefaultLayout = inheritDefaultLayout || !childHasLayout

          if (shouldApplyDefaultLayout) {
            return {
              path: route.path,
              component: layouts[route.meta?.layout || 'default'],
              children: route.path === '/' ? [route] : [{...route, path: ''}],
              meta: {
                isLayout: true
              }
            }
          }
        }
      }

      if (route.meta?.layout) {
        return {
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
